import { inject, Injectable } from '@angular/core';
import { RemoteConfig } from '@angular/fire/remote-config';
import { fetchAndActivate, getValue, Value } from 'firebase/remote-config';

@Injectable({
    providedIn: 'root'
})
export class RemoteConfigService {
    private readonly remoteConfig = inject(RemoteConfig);

    public update(): Promise<boolean> {
        return fetchAndActivate(this.remoteConfig);
    }

    public getItem(key: string): Value {
        return getValue(this.remoteConfig, key);
    }
}
